<template>
  <keep-alive :include="keepAliveInclude">
    <router-view></router-view>
  </keep-alive>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['keepAliveInclude'])
  }
}
</script>
